module.exports = __webpack_public_path__ + "img/couples-050.1f1c8bb3.jpg";